import { CMG_ACCOUNT_TYPE, CDA_ACCOUNT_TYPE, SAVINGS_ACCOUNT_TYPES, SAVINGS_ACCOUNT_TYPES_BUCKETS_ELIGIBLE, } from '../constants';
export function isAllyBank(account) {
    var domainDetails = account.domainDetails;
    return (domainDetails.domain === 'BANK' && !domainDetails.externalAccountIndicator);
}
export function isCMG(account) {
    return (isAllyBank(account) &&
        account.accountType.toUpperCase() === CMG_ACCOUNT_TYPE);
}
export function isCDA(account) {
    var accountType = (account.accountType && account.accountType.toUpperCase()) || '';
    return isAllyBank(account) && accountType === CDA_ACCOUNT_TYPE;
}
export function isAllySavings(account) {
    return (isAllyBank(account) &&
        SAVINGS_ACCOUNT_TYPES.includes(account.accountType.toUpperCase()));
}
export function isAllySavingsBucketsEligible(account) {
    return (isAllyBank(account) &&
        SAVINGS_ACCOUNT_TYPES_BUCKETS_ELIGIBLE.includes(account.accountType.toUpperCase()));
}
export function hasBuckets(account) {
    if (isAllySavingsBucketsEligible(account)) {
        var domainDetails = account.domainDetails;
        if (domainDetails.stkSummary) {
            return domainDetails.stkSummary.bucketSummary.count > 0;
        }
    }
    return false;
}
//# sourceMappingURL=ally-bank.js.map